/* Gesicht auf Socken – Startseite: wechselndes Wort im Banner, wechselnde Bewertungskarte, Produkt-Reiter,
   Slider (sh-hero-slides), Bildwechsel in Kacheln (sh-categories), Stil-Umschalter (sh-cartoon-band, sh-cushion-teaser).
   Keine Bibliotheken. Bei „Bewegung reduzieren“ wird nichts automatisch gewechselt. */
(function () {
  if (window.__shHomeInit) return;
  window.__shHomeInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* „DEIN HUND / DEINE KATZE … AUF SOCKEN!“ – data-words: "Dein~Hund|Deine~Katze|…" */
  function initRotor(root) {
    var rotor = root.querySelector('[data-sh-rotor]');
    if (!rotor || rotor.__shRotor) return;
    rotor.__shRotor = true;
    var preEl = rotor.querySelector('[data-sh-rotor-pre]');
    var wordEl = rotor.querySelector('[data-sh-rotor-word]');
    var items = (rotor.getAttribute('data-words') || '').split('|').filter(Boolean).map(function (pair) {
      var p = pair.split('~');
      return { pre: p[0] || '', word: p[1] || '' };
    });
    var interval = parseInt(rotor.getAttribute('data-interval'), 10) || 2400;
    var index = 0, timer = null;
    if (items.length < 2 || reduce) return;

    function swap(item) {
      wordEl.classList.remove('is-in');
      wordEl.classList.add('is-out');
      setTimeout(function () {
        if (preEl) preEl.textContent = item.pre;
        wordEl.textContent = item.word;
        wordEl.classList.remove('is-out');
        void wordEl.offsetWidth;
        wordEl.classList.add('is-in');
      }, 260);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (document.hidden) return;
      timer = setInterval(function () { index = (index + 1) % items.length; swap(items[index]); }, interval);
    }
    document.addEventListener('visibilitychange', start);
    start();
  }

  /* Bewertungskarte: wechselt automatisch, pausiert bei Maus/Fokus, nie bei „Bewegung reduzieren“. */
  function initReviews(root) {
    if (root.__shReviews) return;
    root.__shReviews = true;
    var slides = root.querySelectorAll('[data-sh-review-slide]');
    if (slides.length < 2 || reduce) return;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var index = 0, timer = null, hovered = false, focused = false;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.hidden = n !== index; });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (hovered || focused || document.hidden) return;
      timer = setInterval(function () { show(index + 1); }, interval);
    }
    root.addEventListener('mouseenter', function () { hovered = true; stop(); });
    root.addEventListener('mouseleave', function () { hovered = false; start(); });
    root.addEventListener('focusin', function () { focused = true; stop(); });
    root.addEventListener('focusout', function () { focused = false; start(); });
    document.addEventListener('visibilitychange', start);
    start();
  }

  /* Produkt-Reiter (Socken / Sneakersocken) */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-sh-tab]');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-sh-tab');
        tabs.forEach(function (t) { t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
        root.querySelectorAll('[data-sh-tabpanel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-sh-tabpanel') !== id;
        });
        root.querySelectorAll('[data-sh-tablink]').forEach(function (l) {
          l.hidden = l.getAttribute('data-sh-tablink') !== id;
        });
      });
    });
  }

  function setHidden(el, hidden) {
    if (hidden) {
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('aria-hidden');
      el.removeAttribute('inert');
    }
  }

  /* Startseiten-Slider (sections/sh-hero-slides.liquid): Überblenden, Reiter mit Fortschrittsbalken.
     Die Dauer steckt in der CSS-Animation des Balkens (--shx-dur); deren Ende schaltet weiter. Maus oder
     Tastaturfokus im Slider halten den Balken an, der Pause-Knopf stoppt ganz. Ein Klick auf einen Reiter zeigt dessen
     Folie und läuft von dort weiter (Joel 2026-10-13: soll beim Auswählen nicht stoppen). */
  function initSlides(root) {
    if (root.__shSlides) return;
    root.__shSlides = true;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-shx-slide]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-shx-tab]'));
    var pauseBtn = root.querySelector('[data-shx-pause]');
    var live = root.querySelector('[data-shx-live]');
    if (slides.length < 2) return;
    var index = 0;
    var paused = reduce || root.getAttribute('data-autoplay') === 'false';

    /* Layout „Wechselnde Motive“ (snippets/sh-hero-motifs.liquid): Motive der aktiven Slide nacheinander zeigen und
       Artikel/Wort der Überschrift mittauschen. Läuft nur, solange der Slider läuft – nicht bei Pause, Maus oder Fokus
       im Slider, verstecktem Browser-Tab oder „Bewegung reduzieren“. Beim Wechsel auf die Slide beginnt es von vorn. */
    var motifs = slides.map(function (s) {
      var box = s.querySelector('[data-shx-mots]');
      if (!box) return null;
      return {
        frames: Array.prototype.slice.call(box.querySelectorAll('[data-shx-mot]')),
        art: s.querySelector('[data-shx-art]'),
        word: s.querySelector('[data-shx-word]'),
        ms: parseInt(box.getAttribute('data-ms'), 10) || 2600,
        i: 0,
        timer: null
      };
    });
    function motifShow(m, i) {
      m.i = (i + m.frames.length) % m.frames.length;
      m.frames.forEach(function (f, n) { f.classList.toggle('is-on', n === m.i); });
      var f = m.frames[m.i];
      if (m.art) m.art.textContent = f.getAttribute('data-art');
      if (m.word) m.word.textContent = f.getAttribute('data-word');
    }
    function motifRun(reset) {
      motifs.forEach(function (m, n) {
        if (!m) return;
        clearInterval(m.timer);
        m.timer = null;
        if (n !== index) return;
        if (reset) motifShow(m, 0);
        if (paused || m.frames.length < 2) return;
        m.timer = setInterval(function () {
          if (paused || document.hidden || root.classList.contains('is-held')) return;
          motifShow(m, m.i + 1);
        }, m.ms);
      });
    }

    function run() {
      tabs.forEach(function (t) { t.classList.remove('is-run'); });
      var tab = tabs[index];
      if (!tab || paused) return;
      void tab.offsetWidth; /* Animation neu starten */
      tab.classList.add('is-run');
    }
    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === index);
        setHidden(s, n !== index);
      });
      tabs.forEach(function (t, n) { t.setAttribute('aria-pressed', n === index ? 'true' : 'false'); });
      run();
      motifRun(true);
    }
    function setPaused(p) {
      paused = p;
      root.classList.toggle('is-paused', p);
      if (pauseBtn) pauseBtn.setAttribute('aria-label', p ? 'Bildwechsel fortsetzen' : 'Bildwechsel anhalten');
      if (live) live.setAttribute('aria-live', p ? 'polite' : 'off');
      run();
      motifRun(false);
    }

    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n); });
      var fill = t.querySelector('[data-shx-fill]');
      if (fill) {
        fill.addEventListener('animationend', function () {
          if (n === index && !paused) show(index + 1);
        });
      }
    });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!paused); });

    /* Anhalten nur bei echter Maus über dem Slider und bei Tastatur-Fokus – nicht nach Antippen (Handy) oder nach
       einem Klick auf einen Reiter, der den Fokus behält; sonst stünde der Slider nach der Auswahl doch still. */
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') root.classList.add('is-held'); });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') root.classList.remove('is-held'); });
    root.addEventListener('focusin', function (e) {
      var keyboard = false;
      try { keyboard = e.target.matches(':focus-visible'); } catch (err) {}
      if (keyboard) root.classList.add('is-held');
    });
    root.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !root.contains(e.relatedTarget)) root.classList.remove('is-held');
    });

    /* Theme-Editor: gewählten Block zeigen */
    root.__shShow = function (el) {
      var n = slides.indexOf(el);
      if (n < 0) return;
      if (!paused) setPaused(true);
      show(n);
    };

    setPaused(paused);
  }

  /* Bildwechsel in Kacheln (z. B. „Was dürfen wir bedrucken?“): [data-sh-fade] mit mehreren .sh-fade-img (erstes mit .is-on).
     Jede Kachel wechselt alle 3,3 s, leicht versetzt. Hält bei Maus/Fokus und ohne Sichtbarkeit an. */
  var fadeGroups = [];
  var fadeTick = 0;
  var fadeTimer = null;
  function fadeStep() {
    if (document.hidden) return;
    fadeTick += 1;
    fadeGroups.forEach(function (g) {
      if (g.held || !g.visible || !document.body.contains(g.el)) return;
      var idx = Math.floor((fadeTick + g.offset) / 3) % g.imgs.length;
      if (idx === g.index) return;
      g.index = idx;
      g.imgs.forEach(function (img, n) { img.classList.toggle('is-on', n === idx); });
    });
  }
  function initFades(root) {
    if (root.__shFades || reduce) return;
    root.__shFades = true;
    var tiles = root.querySelectorAll('[data-sh-fade]');
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.target.__shFade) en.target.__shFade.visible = en.isIntersecting; });
    }) : null;
    tiles.forEach(function (tile, i) {
      var imgs = Array.prototype.slice.call(tile.querySelectorAll('.sh-fade-img'));
      if (imgs.length < 2) return;
      var g = { el: tile, imgs: imgs, offset: i, index: 0, held: false, visible: !io };
      tile.__shFade = g;
      var link = tile.closest('a') || tile;
      link.addEventListener('mouseenter', function () { g.held = true; });
      link.addEventListener('mouseleave', function () { g.held = false; });
      link.addEventListener('focus', function () { g.held = true; });
      link.addEventListener('blur', function () { g.held = false; });
      if (io) io.observe(tile);
      fadeGroups.push(g);
    });
    if (fadeGroups.length && !fadeTimer) fadeTimer = setInterval(fadeStep, 1100);
  }

  /* Umschalter mit Bildern (Cartoon-Band, Kissen): [data-sh-switch] mit Knöpfen [data-sh-switch-btn="i"]
     und Ebenen [data-sh-switch-panel="i"] (auch mehrere je Stil, z. B. Socke und Kopf).
     Optional automatisch weiter: data-auto="3300" und ein Pause-Knopf [data-sh-switch-pause]. */
  function initSwitch(root) {
    if (root.__shSwitch) return;
    root.__shSwitch = true;
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-sh-switch-btn]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sh-switch-panel]'));
    var names = root.querySelectorAll('[data-sh-switch-name]');
    var pauseBtn = root.querySelector('[data-sh-switch-pause]');
    var count = btns.length || 1;
    var auto = parseInt(root.getAttribute('data-auto'), 10) || 0;
    var index = 0;
    btns.forEach(function (b, n) { if (b.getAttribute('aria-pressed') === 'true') index = n; });
    var timer = null;
    var stopped = reduce || !auto || count < 2;

    function show(i) {
      index = (i + count) % count;
      btns.forEach(function (b, n) { b.setAttribute('aria-pressed', n === index ? 'true' : 'false'); });
      panels.forEach(function (p) {
        var on = parseInt(p.getAttribute('data-sh-switch-panel'), 10) === index;
        p.classList.toggle('is-on', on);
        if (p.tagName === 'IMG') p.setAttribute('alt', on ? (p.getAttribute('data-alt') || '') : '');
      });
      var label = btns[index] ? btns[index].getAttribute('data-name') : '';
      names.forEach(function (el) { if (label) el.textContent = label; });
    }
    function stopTimer() { if (timer) { clearInterval(timer); timer = null; } }
    function startTimer() {
      stopTimer();
      if (stopped || document.hidden) return;
      timer = setInterval(function () { show(index + 1); }, auto);
    }
    function setStopped(s) {
      stopped = s;
      root.classList.toggle('is-paused', s);
      if (pauseBtn) pauseBtn.setAttribute('aria-label', s ? 'Bildwechsel fortsetzen' : 'Bildwechsel anhalten');
      startTimer();
    }
    btns.forEach(function (b, n) {
      b.addEventListener('click', function () {
        show(n);
        if (auto) setStopped(true);
      });
    });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setStopped(!stopped); });
    if (auto) {
      document.addEventListener('visibilitychange', startTimer);
      setStopped(stopped);
    }
    root.__shShow = function (el) {
      var n = btns.indexOf(el);
      if (n < 0 && el) {
        var id = el.getAttribute('data-sh-switch-block');
        btns.forEach(function (b, k) { if (b.getAttribute('data-sh-switch-block') === id) n = k; });
      }
      if (n < 0) return;
      show(n);
      if (auto) setStopped(true);
    };
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-sh-hero]').forEach(initRotor);
    s.querySelectorAll('[data-sh-reviews]').forEach(initReviews);
    s.querySelectorAll('[data-sh-tabs]').forEach(initTabs);
    s.querySelectorAll('[data-sh-slides]').forEach(initSlides);
    s.querySelectorAll('[data-sh-fades]').forEach(initFades);
    s.querySelectorAll('[data-sh-switch]').forEach(initSwitch);
  }

  /* Theme-Editor: gewählten Block im Slider bzw. Umschalter anzeigen */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var root = el && el.closest && el.closest('[data-sh-slides], [data-sh-switch]');
    if (root && root.__shShow) root.__shShow(el);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Im Theme-Editor neu initialisieren, wenn eine Section neu gerendert wird */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
